import * as React from "react"

import { NavLink } from "react-router-dom"
import { concatClassNames } from "helpers/jsxHelpers"

import { NavTabsContentProps } from "../interfaces"

type NavTabsListProps = NavTabsContentProps

const NavTabsList: React.FC<NavTabsListProps> = ({ tabs = [], className }) => {
	const navTabsStyles = concatClassNames(["nav-tabs", className])

	return (
		<div className={navTabsStyles}>
			{tabs.map(
				({ active = true, pathname, text }) =>
					active && (
						<NavLink
							data-testid="link"
							role="nav-tab"
							key={pathname}
							activeClassName="isCurrent"
							to={pathname}
						>
							{text}
						</NavLink>
					)
			)}
		</div>
	)
}

export default NavTabsList
